import * as React from "react";

import Form from "@ant-design/compatible/es/form";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import RightSideIcon from "@impero-com/common/components/rightSideIcon";
import passwordSvg from "@impero-com/common/img/password-login.svg";
import { AjaxManager } from "@impero-com/common/utils/ajax";
import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";
import { Link } from "react-router-dom";

import type { UserProfile } from "api/generated/model";

import { orgLogout } from "../utils/logout";

export class AlreadyLoggedIn extends React.Component<
    AlreadyLoggedInProps,
    AlreadyLoggedInState
> {
    constructor(props: AlreadyLoggedInProps) {
        super(props);
        this.state = {
            status: { type: "DEFAULT" },
        };
    }

    render() {
        const { orgProfileCookie, text } = this.props;
        const FormItem = Form.Item;

        const userEmail =
            orgProfileCookie && orgProfileCookie.email
                ? orgProfileCookie.email
                : "";

        let subtitle: string;
        switch (text) {
            case "RegisterUser_YouAreAlreadyLoggedIn":
                subtitle = t("RegisterUser_YouAreAlreadyLoggedIn", {
                    email: userEmail,
                });
                break;
            case "ResetPassword_YouAreAlreadyLoggedIn":
                subtitle = t("ResetPassword_YouAreAlreadyLoggedIn", {
                    email: userEmail,
                });
                break;
            default:
                assertNever(text);
        }

        return (
            <FormCardContainer
                rightSide={
                    <RightSideIcon icon={passwordSvg} customImages={false} />
                }
            >
                <FormTitle title={t("AlreadyLoggedIn")} />
                <FormSubtitle subtitle={subtitle} />
                <FormCard>
                    <FormItem>
                        <Button
                            id="login-button"
                            variant="primary"
                            type="submit"
                            block
                            onClick={orgLogout}
                        >
                            {t("Logout")}
                        </Button>
                    </FormItem>
                </FormCard>
                <CardFooter>
                    <Link to="/">{t("Cancel")}</Link>
                </CardFooter>
            </FormCardContainer>
        );
    }
}

type TextLocizeKey =
    | "RegisterUser_YouAreAlreadyLoggedIn"
    | "ResetPassword_YouAreAlreadyLoggedIn";

interface AlreadyLoggedInProps {
    text: TextLocizeKey;
    ajaxManager: AjaxManager;
    orgProfileCookie: UserProfile | null;
}

type AlreadyLoggedInStatus = { type: "DEFAULT" } | { type: "TRANSITIONING" };
interface AlreadyLoggedInState {
    status: AlreadyLoggedInStatus;
}
